export enum LinkspaceParam {
    CategoryId = 'categoryId',
    ServiceId = 'serviceId',
    PictogramId = 'pictogramId',
}
